/** Budget lug'ati (uz) */
export default {
  title: "Byudjet",
  subtitle: "{{scope}} · {{period}} · reja va fakt",
  month: "Oy",
  editPlan: "Rejani tahrirlash",
  tabs: { overview: "Umumiy", money: "Pul", expenses: "Xarajatlar", salaries: "Maoshlar", bonuses: "Bonuslar", placements: "Carrier to'lovlari" },
  scope: { branch: "Filial", all: "Barcha filiallar", yours: "Sizning filialingiz" },
  cat: { salaries: "Maoshlar", expenses: "Xarajatlar", bonuses: "Bonuslar" },
  total: "Jami",
  status: "Holat",
  conflict: "{{who}} o'zgartirgan. Qayta yuklandi.",
  someoneElse: "Boshqa foydalanuvchi",
  plan: {
    saved: "Reja saqlandi",
    saveFailed: "Rejani saqlab bo'lmadi.",
    title: "Reja · {{period}}",
    desc: "Har filial uchun oylik limitlar. Haqiqiy sarf shu raqamlar bilan solishtiriladi.",
    save: "Rejani saqlash",
    branch: "Filial",
  },
  overview: {
    noPlan: "{{month}} uchun reja belgilanmagan.",
    noPlanSub: "Haqiqiy sarf limitsiz ko'rsatilmoqda.",
    noPlanOwner: "Limit qo'yish uchun yuqoridagi \"Rejani tahrirlash\" tugmasidan foydalaning.",
    noPlanManager: "Rejani egasi belgilaydi.",
    planKpi: "Reja · {{month}}",
    planSub_one: "{{count}} filial, 3 kategoriya",
    planSub_other: "{{count}} filial, 3 kategoriya",
    actual: "Fakt",
    ofPlan: "rejaning {{pct}}%",
    noPlanShort: "reja yo'q",
    costPerHire: "Bir ishga olish narxi",
    costSub_one: "{{count}} ishga olish · maoshlar + xarajatlar + bonuslar",
    costSub_other: "{{count}} ishga olish · maoshlar + xarajatlar + bonuslar",
    over: "Byudjetdan oshgan",
    overBranches_one: "{{count}} filial",
    overBranches_other: "{{count}} filial",
    within: "Barcha filiallar reja doirasida",
    byCategory: "Kategoriya bo'yicha · {{month}}",
    pending: "kutmoqda",
    draft: "qoralama",
    alerts: "Ogohlantirishlar",
    noAlerts: "Bu oyda e'tibor talab qiladigan narsa yo'q.",
    details: "Batafsil →",
    review: "Ko'rish →",
    branches: "Filiallar · {{month}}",
    branchesSub: "Har filial bo'yicha reja va fakt. Bir ishga olish narxi = jami sarf ÷ tasdiqlangan ishga olishlar.",
    of: "/ {{plan}} · {{pct}}%",
    noPlanBar: "· reja yo'q",
    extra: "+ {{amount}} {{label}}",
    cols: { branch: "Filial", plan: "Reja", actual: "Fakt", used: "Sarflangan", salaries: "Maoshlar", expenses: "Xarajatlar", bonuses: "Bonuslar", hires: "Ishga olingan", costPerHire: "Narx / ishga olish" },
  },
  expenses: {
    archived: "Xarajat arxivlandi",
    archiveFailed: "Xarajatni arxivlab bo'lmadi.",
    add: "+ Xarajat qo'shish",
    categoryAll: "Kategoriya: hammasi",
    statusAll: "Holat: hammasi",
    category: "Kategoriya",
    searchPlaceholder: "Tavsif bo'yicha qidirish",
    searchAria: "Xarajatlarni qidirish",
    emptyFiltered: "Bu filtrlarga mos xarajat yo'q",
    emptyMonth: "{{month}} oyida xarajatlar yo'q",
    emptyDesc: "Filial menejeri kiritgan xarajatlar egasiga tasdiqqa boradi.",
    cols: { date: "Sana", category: "Kategoriya", description: "Tavsif", branch: "Filial", amount: "Summa", submittedBy: "Kim kiritgan", receipt: "Chek", status: "Holat", actions: "Sabab / amallar" },
    receipt: "Chek",
    reason: "Sabab: {{reason}}",
    notSpecified: "ko'rsatilmagan",
    by: "{{name}}",
    totalLabel: "Jami (tasdiqlangan + kutayotgan):",
    rejectedSum: " · rad etilgan {{amount}}",
    paginationLabel: "xarajat",
    archiveTitle: "Xarajat arxivlansinmi?",
    archiveBody: "Hech narsa o'chirilmaydi: xarajat ro'yxatlardan yashiriladi va audit jurnalida qoladi.",
    archiveBodyRequest: " Uning tasdiq so'rovi o'zgarishsiz qoladi.",
    summary: { plan: "{{month}} rejasi {{plan}}", notSet: "belgilanmagan", spent: "· Sarflandi {{amount}}", waiting: "Tasdiq kutmoqda · {{amount}}" },
    modal: {
      tooLarge: "Fayl {{mb}} MB dan katta.",
      dateRequired: "Sana majburiy.",
      chooseCategory: "Kategoriyani tanlang.",
      positiveAmount: "Musbat summa kiriting.",
      chooseBranch: "Filialni tanlang.",
      receiptRequired: "Chek majburiy.",
      updated: "Xarajat yangilandi",
      submitted: "Tasdiqqa yuborildi",
      submittedSub: "Egasi uni Tasdiqlar bo'limida ko'radi.",
      added: "Xarajat qo'shildi",
      saveFailed: "Xarajatni saqlab bo'lmadi.",
      editTitle: "Xarajatni tahrirlash",
      addTitle: "Xarajat qo'shish",
      submit: "Tasdiqqa yuborish",
      date: "Sana", category: "Kategoriya", amount: "Summa", currency: "Valyuta", branch: "Filial", description: "Tavsif", receipt: "Chek",
      choose: "Tanlang…",
      noConversion: "Kiritilganidek ko'rsatiladi; konvertatsiya yo'q",
      descPlaceholder: "Facebook reklama: driver lidlari (1-6 okt)",
      keepReceipt: "Joriy chekni saqlab qolish uchun bo'sh qoldiring.",
      dropHere: "Chekni shu yerga tashlang yoki",
      browse: "faylni tanlang",
      fileTypes: "JPG, PNG yoki PDF, {{mb}} MB gacha",
      removeFile: "Faylni olib tashlash",
      current: "Joriy: {{name}}",
      goesToOwner: "Xarajat egasiga tasdiqqa boradi. Ungacha \"Kutmoqda\" holatida ko'rsatiladi.",
    },
  },
  salaries: {
    saved: "Maoshlar saqlandi",
    savedSub_one: "{{count}} qator · {{month}}",
    savedSub_other: "{{count}} qator · {{month}}",
    saveFailed: "Maoshlarni saqlab bo'lmadi.",
    markedPaid: "To'langan deb belgilandi · {{name}}",
    markedUnpaid: "To'lanmagan deb belgilandi · {{name}}",
    updateFailed: "Yangilab bo'lmadi.",
    markedCount: "{{count}} ta to'langan deb belgilandi",
    subtitle: "{{scope}} · maoshlar · {{month}}",
    markSelected: "Tanlanganlarni to'langan deb belgilash",
    roleAll: "Rol: hammasi",
    role: "Rol",
    paid: "To'langan",
    paidAll: "To'lov: hammasi",
    notPaid: "To'lanmagan",
    visibility: "Faqat egasi va sizning filial menejeringizga ko'rinadi",
    empty: "Bu filtrlarga mos xodim yo'q",
    cols: { employee: "Xodim", role: "Rol", branch: "Filial", amount: "Oylik maosh", paid: "To'langan", paidDate: "To'lov sanasi", note: "Izoh" },
    selectAllUnpaid: "Barcha to'lanmaganlarni tanlash",
    select: "{{name}} ni tanlash",
    lastMonth: "{{amount}} (o'tgan oy)",
    salaryAria: "{{name}} maoshi",
    enterFirst: "Avval summani kiriting va saqlang",
    ownerSets: "Bu maoshni kompaniya egasi belgilaydi",
    ownerOnlyUnpaid: "Faqat egasi to'lanmagan deb belgilay oladi",
    bankTransfer: "Bank o'tkazmasi",
    totalRow_one: "Jami · {{count}} xodim · to'langan {{paid}} / {{count}}",
    totalRow_other: "Jami · {{count}} xodim · to'langan {{paid}} / {{count}}",
    note: "Tizim faqat summani yozib boradi; pul bank orqali to'lanadi. To'langan qatorlar qulflanadi.",
    unsaved_one: "{{count}} ta saqlanmagan o'zgarish",
    unsaved_other: "{{count}} ta saqlanmagan o'zgarish",
    discard: "Bekor qilish",
    save: "Maoshlarni saqlash",
  },
  bonuses: {
    supplement: "Qo'shimcha",
    calculated: "{{month}} uchun hisoblandi",
    calculatedSub: "{{count}} ta recruiter · tasdiqlangan va to'langan bonuslar o'zgarmadi",
    calculatedExtra: "Qo'shimcha bonus: {{count}} ta (keyin tasdiqlangan hire'lar)",
    calcFailed: "Hisoblab bo'lmadi.",
    approved_one: "{{count}} ta bonus tasdiqlandi",
    approved_other: "{{count}} ta bonus tasdiqlandi",
    approvedSub: "Recruiterlarga xabar berildi.",
    approveFailed: "Tasdiqlab bo'lmadi.",
    markedCount: "{{count}} ta to'langan deb belgilandi",
    updateFailed: "Yangilab bo'lmadi.",
    subtitle: "{{scope}} · recruiter bonuslari · {{month}}",
    markPaid: "To'langan deb belgilash ({{count}})",
    calculate: "{{month}} uchun hisoblash",
    approveAll: "Hammasini tasdiqlash ({{count}})",
    rule: "Qoida: {{name}}",
    ruleBase: "· har ishga olish uchun {{perHire}} + 30 kun ishlagan har biri uchun {{per30}}",
    rule60: " + 60 kun uchun {{amount}}",
    rule90: " + 90 kun uchun {{amount}}",
    editInAdmin: "Admin → Sozlamalar'da tahrirlash",
    statusAll: "Holat: hammasi",
    withBonusOnly: "Faqat bonusi borlar",
    summary: "{{count}} recruiter · {{draft}} qoralama · {{approved}} tasdiqlangan · {{paid}} to'langan",
    emptyMonth: "{{month}} uchun bonuslar hisoblanmagan",
    emptyDesc: "Bonuslar status tarixidagi tasdiqlangan ishga olishlar va saqlanish tekshiruvlaridan hisoblanadi.",
    emptyFiltered: "Bu filtrlarga mos bonus yo'q",
    cols: { recruiter: "Recruiter", hires: "Ishga olingan", stayed: "Qoldi 30 / 60 / 90 k", rule: "Qoida", calculated: "Hisoblangan", adjustment: "Tuzatish", total: "Jami", status: "Holat" },
    selectApproved: "Tasdiqlanganlarni tanlash",
    select: "{{name}} ni tanlash",
    totalRow_one: "Jami · {{count}} recruiter",
    totalRow_other: "Jami · {{count}} recruiter",
    approveTitle_one: "{{count}} ta bonusni tasdiqlash · {{month}}",
    approveTitle_other: "{{count}} ta bonusni tasdiqlash · {{month}}",
    approveDesc: "Tasdiqlangan bonuslar yakuniy: ular byudjetda hisoblanadi va recruiterlar summani o'z dashboardida ko'radi.",
    approveSum: "Tasdiqlash {{sum}}",
    hiresShort: "· {{count}} ta ishga olish",
    adjSaved: "Tuzatish saqlandi · {{name}}",
    saveFailed: "Saqlab bo'lmadi.",
    adjustment: "Tuzatish",
    adjustmentNote: "Tuzatish izohi",
    notePlaceholder: "Izoh",
    hide: "Yashirish",
    details: "Batafsil",
    d: {
      hiresIn: "{{month}} oyidagi ishga olishlar · {{count}} × {{per}} = {{sum}}",
      hiredOn: "• {{driver}} · ishga olingan {{date}}",
      start: " · boshlagan {{date}}",
      noHires: "Tasdiqlangan ishga olishlar yo'q",
      stayed30: "30 kun qolganlar · {{count}} × {{per}} = {{sum}}",
      d60: " · 60 k",
      d90: " · 90 k",
      noneYet: "Hali yo'q",
      result: "Natija",
      calculated: "• Hisoblangan: {{amount}}",
      adjustment: "• Tuzatish: {{amount}}",
      total: "• Jami: {{amount}}",
      status: "• Holat: {{status}}",
      by: " · {{name}}",
      paid: " · to'langan {{date}}",
    },
  },
  placements: {
    subtitle: "{{scope}} · ishga olingan driverlar uchun carrier'lar to'laydigan pul",
    rule: "Muddat: driver ishga chiqqandan {{days}} kun keyin (Sozlamalar)",
    status: "To'lov holati",
    search: "Driver yoki carrier qidirish",
    unit: "joylashtirish",
    empty: "Hech narsa yo'q",
    emptyDesc: "Driver ishga olinganda bu yerda paydo bo'ladi.",
    state: { all: "Hamma holatlar", open: "Ochiq: kutilmoqda va muddati o'tgan", overdue: "Muddati o'tgan", due: "Kutilmoqda (muddati kelmagan)", paid: "To'langan", partial: "Qisman to'langan", not_paid: "To'lanmagan" },
    kpi: {
      overdue: "Muddati o'tgan", overdueSub: "muddat o'tdi, to'lanmagan",
      due: "Kutilmoqda", dueSub: "muddati hali kelmagan", expected: "kutilayotgan {{amount}}",
      paid: "To'langan", partial_one: "{{count}} tasi qisman", partial_other: "{{count}} tasi qisman",
      notPaid: "To'lanmagan",
      approvalPending: "Tasdiq kutilmoqda", approvalPendingSub: "hire hali tasdiqlanmagan",
    },
    cols: { driver: "Driver", recruiter: "Recruiter", branch: "Filial", carrier: "Carrier", started: "Ishga chiqdi", due: "Muddat", amount: "Summa", status: "Holat", note: "Izoh" },
    modalTitle: "Carrier to'lovi",
    started: "ishga chiqdi {{date}}",
    dueOn: "muddat {{date}}",
    amount: "Summa ($)",
    amountHint: "Noma'lum bo'lsa bo'sh qoldiring",
    paidOn: "To'langan sana",
    note: "Izoh",
    notePlaceholder: "masalan: boshqa driver o'rniga (recover)",
    filters: { carrier: "Hamma carrier'lar", recruiter: "Hamma recruiterlar", approval: "Hire tasdig'i: hammasi", approvalYes: "Hire tasdiqlangan", approvalNo: "Tasdiq kutilmoqda", period: "Ishga chiqqan oy: hammasi" },
    emptyFiltered: "Bu filtrlarga mos yozuv yo'q.",
    addPayment: "To'lov",
    recordPayment: "To'lovni yozish",
    receivedLine: "tushgan {{received}}",
    remainingLine: "qoldi {{remaining}}",
    legacy: "holat importdan · tushum yozilmagan",
    remainingBox: "Tushgan {{received}} / {{total}} · qoldi {{remaining}}",
    paymentTitle: "Carrier'dan pul tushdi",
    paymentAmount: "Tushgan summa ($)",
    paymentAmountRequired: "Summani kiriting.",
    paymentAccountRequired: "Pul tushgan hisobni tanlang.",
    paymentDate: "Sana",
    paymentTime: "Vaqt",
    paymentNotePlaceholder: "masalan: o'tkazma raqami",
    paymentSaved: "{{amount}} yozildi · {{name}}",
    convertedHint: "Hisob {{currency}} da: to'lov kuni kursi bilan aylantiriladi.",
    editTitle: "To'lov shartlari",
    dueDate: "Muddat",
    editReceivedNote: "Allaqachon {{received}} tushgan: holat tushumlardan hisoblanadi.",
    writeOffTitle: "{{name}} to'lanmadi deb belgilansinmi?",
    writeOffDesc: "Carrier to'lamasa shunday qilinadi. Keyin qayta ochish mumkin.",
    writeOff: "To'lanmadi deb belgilash",
    reopen: "Qayta ochish",
    voidTitle: "Bu to'lov bekor qilinsinmi?",
    voidDesc: "{{amount}} → {{account}} daftardan olib tashlanadi (audit'da qoladi); holat qayta hisoblanadi.",
    void: "To'lovni bekor qilish",
    voided: "To'lov bekor qilindi · {{name}}",
    saved: "To'lov saqlandi · {{name}}",
  },
  money: {
    income: "Kirim",
    expense: "Chiqim",
    transfer: "O'tkazma",
    totalBalance: "Hisoblardagi pul",
    totalHint: "Hamma hisoblar USD da, bugungi kurs bilan",
    inCurrency: "{{currency}} da",
    rate: "Valyuta kursi",
    rateValue: "1 USD = {{rate}} UZS",
    noRate: "Kurs hali yo'q",
    rateCbu: "Markaziy bank · {{date}}",
    rateManual: "Qo'lda kiritilgan · {{date}}",
    rateTitle: "USD/UZS kursi",
    rateDesc: "Markaziy bank kursi har kuni avtomatik olinadi. Qo'lda kiritilgan kun kursi ustidan yozilmaydi.",
    rateSaved: "Kurs saqlandi",
    company: "Kompaniya",
    newAccount: "Hisob ochish",
    archived: {
      link: "Arxivdagi hisoblar ({{count}})",
      title: "Arxivdagi hisoblar",
      desc: "Ular ro'yxatda va jami summada yo'q. Qayta ishlatish yoki undan qilingan to'lovni bekor qilish uchun hisobni tiklang.",
      restore: "Tiklash",
      restored: "{{name}} ro'yxatga qaytdi",
    },
    editAccount: "Hisobni tahrirlash",
    accountDesc: "Naqd kassa, karta yoki bank hisobi. Kartaning faqat oxirgi 4 raqami saqlanadi.",
    accountCreated: "Hisob ochildi · {{name}}",
    accountSaved: "Hisob saqlandi",
    deleteTitle: "{{name}} o'chirilsinmi?",
    deleteDesc: "Qoldiq: {{balance}}. Hisob ro'yxatdan va jami summadan chiqadi; yozuvlari daftar va audit log'da qoladi, bog'langan to'lovlar to'langanligicha qoladi.",
    deleted: "O'chirildi · {{name}}",
    reconcileTitle: "{{name}}: qoldiqni solishtirish",
    reconcileDesc: "Karta yoki kassadagi haqiqiy qoldiqni kiriting. Farq bitta tuzatish yozuvi bo'ladi; tarix o'zgarmaydi.",
    reconcileIn: "{{amount}} kirim (tuzatish) yoziladi",
    reconcileOut: "{{amount}} chiqim (tuzatish) yoziladi",
    reconcileSame: "Qoldiq allaqachon mos.",
    reconciled: "{{account}} {{amount}} ga solishtirildi",
    noAccountsTitle: "Hali hisob yo'q",
    noAccountsManager: "Hisoblarni owner ochadi va filialingizga biriktirishi mumkin.",
    filterByAccount: "Shu hisob harakatlarini ko'rsatish",
    accountKinds: { cash: "Naqd", card: "Karta", bank: "Bank hisobi" },
    kinds: { fee: "Carrier to'lovi", income: "Kirim", expense: "Xarajat", salary: "Maosh", bonus: "Bonus", transfer: "O'tkazma", adjustment: "Tuzatish" },
    flow: { all: "Hammasi", in: "Kirim", out: "Chiqim", transfer: "O'tkazmalar" },
    ledger: "Kirim-chiqim · {{month}}",
    ledgerSub: "Hisoblardagi har bir pul harakati. Tahrirlash yoki bekor qilish -- qatorda o'ng tugma.",
    ledgerFor: "Hisob: {{account}}",
    allAccounts: "Hamma hisoblar",
    searchPh: "Izoh yoki kimdan/kimga",
    movements: "harakat",
    emptyTitle: "Bu oyda pul harakati yo'q",
    emptyDesc: "Kirim, chiqim va o'tkazmani yuqoridagi tugmalar bilan yozing. To'langan maosh, bonus va xarajatlar shu yerga o'zi tushadi.",
    emptyNoAccounts: "Avval hisob oching.",
    toAcc: "{{account}} ga",
    fromAcc: "{{account}} dan",
    col: { date: "Sana", what: "Nima", account: "Hisob", type: "Turi", amount: "Summa", usd: "USD da", balance: "Qoldiq" },
    moveTitle: { income: "Kirim", expense: "Chiqim", adjustment: "Qoldiqni tuzatish" },
    moveDesc: {
      income: "Carrier to'lovidan boshqa tushum: investitsiya, qaytarilgan pul va h.k. Carrier to'lovlari -- Carrier to'lovlari bo'limida.",
      expense: "Tasdiqlangan xarajat sifatida yoziladi va bir qadamda hisobdan to'lanadi.",
      adjustment: "Faqat haqiqiy qoldiq ko'rsatilganidan farq qilsa (masalan kassani sanagandan keyin).",
    },
    saved: {
      income: "{{amount}} {{account}} ga tushdi",
      expense: "{{amount}} {{account}} dan to'landi",
      adjustment: "{{account}} qoldig'i tuzatildi",
    },
    editMove: "Harakatni tahrirlash",
    editLinkedHint: "Bog'langan to'lovning summasi va sanasi o'zgarmaydi: bekor qilib, qaytadan yozing.",
    transferTitle: "Hisoblar orasida o'tkazma",
    transferDesc: "Masalan naqddan kartaga yoki USD dan UZS ga. Ikkala tomoni ham yoziladi.",
    transferDo: "O'tkazish",
    transferred: "O'tkazildi: {{from}} → {{to}}",
    voidTitle: "Bu harakat bekor qilinsinmi?",
    voidDesc: "{{account}} dagi {{amount}} endi qoldiqqa hisoblanmaydi.",
    voidLinked: "Maosh yoki bonus yana to'lanmagan bo'ladi.",
    voidTransfer: "O'tkazmaning ikkala tomoni ham bekor qilinadi.",
    voided: "Harakat bekor qilindi",
    menu: {
      income: "Kirim",
      expense: "Chiqim",
      transfer: "O'tkazma",
      edit: "Hisobni tahrirlash",
      reconcile: "Qoldiqni solishtirish",
      delete: "O'chirish",
      openLinked: "Yozuvni ochish",
      openDriver: "Driverni ochish",
      editMove: "Tahrirlash",
      void: "Harakatni bekor qilish",
    },
    f: {
      name: "Nomi",
      namePh: "Masalan: Ofis kassasi, Kapitalbank Humo",
      kind: "Turi",
      currency: "Valyuta",
      currencyLocked: "Pul harakati bo'lgach o'zgarmaydi",
      bank: "Bank / karta",
      bankPh: "Masalan: Kapitalbank Humo",
      last4: "Karta: oxirgi 4 raqam",
      last4Hint: "To'liq raqam hech qachon saqlanmaydi",
      branch: "Filial",
      branchHint: "Filial tanlansa, uning menejeri ham bu hisobni ko'radi va yozadi. Tanlanmasa -- faqat owner.",
      company: "Kompaniya (faqat owner)",
      opening: "Boshlang'ich qoldiq, {{currency}}",
      openingDate: "Qoldiq sanasi",
      note: "Izoh",
      account: "Hisob",
      direction: "Yo'nalish",
      adjIn: "Qoldiqqa qo'shish",
      adjOut: "Qoldiqdan ayirish",
      ledgerBalance: "Daftardagi qoldiq",
      actualBalance: "Haqiqiy qoldiq, {{currency}}",
      amount: "Summa, {{currency}}",
      date: "Sana",
      time: "Vaqt",
      category: "Kategoriya",
      chooseCategory: "Kategoriyani tanlang",
      noCategory: "Kategoriyasiz",
      branchFromAccount: "Standart: {{branch}} (hisob filiali)",
      noBranch: "Filialsiz",
      counterparty: "Kimdan",
      counterpartyPh: "Masalan: owner, yetkazib beruvchi qaytardi",
      description: "Izoh",
      from: "Qayerdan",
      to: "Qayerga",
      received: "Tushdi, {{currency}}",
      receivedHint: "1 USD = {{rate}} UZS bo'yicha taklif; bank kursi boshqacha bo'lsa o'zgartiring",
      rate: "1 USD necha UZS",
    },
  },
  commission: {
    label: "Komissiya, %",
    hint: "Ixtiyoriy. Kategoriyadan qo'yiladi; bo'sh yoki 0 — komissiyasiz.",
    invalid: "0 dan 99.99 gacha kiriting.",
    resultIn: "Komissiya {{fee}} · hisobga tushadi {{net}}",
    resultOut: "Komissiya {{fee}} · hisobdan chiqadi {{net}}",
    rowIn: "{{base}} − {{pct}}% komissiya",
    rowOut: "{{base}} + {{pct}}% komissiya",
  },
  pay: {
    paying: "To'lanadi:",
    receiving: "Tushadi:",
    fromAccount: "Qaysi hisobdan",
    toAccount: "Qaysi hisobga tushdi",
    choose: "Hisobni tanlang",
    noAccounts: "Hali hisob yo'q: owner ularni Budjet → Pul bo'limida ochadi.",
    noAccount: "Hisobsiz (faqat to'langan deb belgilash)",
    noAccountHint: "Pul hech qaysi hisob qoldig'iga yozilmaydi.",
    date: "Sana",
    time: "Vaqt",
    converted: "Hisobdan: {{amount}} (1 USD = {{rate}} UZS; aniq summa -- to'lov kuni kursi bilan)",
    noRate: "USD/UZS kursi hali yo'q.",
    balanceAfter: "Qoldiq: {{before}} → {{after}}",
    insufficient: "Balans yetarli emas: bu hisobda {{short}} yetishmaydi.",
    markPaid: "To'landi deb belgilash",
    pay: "To'lash",
    salaryTitle_one: "Maoshni to'lash",
    salaryTitle_other: "{{count}} ta maoshni to'lash",
    bonusTitle_one: "Bonusni to'lash",
    bonusTitle_other: "{{count}} ta bonusni to'lash",
    expenseTitle: "Xarajatni to'lash",
    expensePaid: "Xarajat to'landi",
    payExpense: "To'lash",
    paidFrom: "To'langan · {{account}}",
    feeAccountHint: "Pul tushgan hisobni tanlasangiz, u hisob qoldig'ida ko'rinadi",
    receivedNow: "Hozir tushdi, USD",
    receivedHint: "Bo'sh: to'lovning to'liq summasi",
  },
  cash: {
    onAccounts: "Hisoblardagi pul",
    noAccounts: "Hisoblarni Pul bo'limida oching",
    in: "Kirim · {{month}}",
    out: "Chiqim · {{month}}",
    net: "Sof · {{month}}",
    netSub: "Kirim minus chiqim (o'tkazmalarsiz)",
    vsPrev: "o'tgan oyga nisbatan {{pct}}%",
    noPrev: "o'tgan oyda yo'q",
    missingRate: "Ba'zi UZS summalari uchun kurs hali yo'q",
    chartTitle: "Kirim va chiqim · 12 oy",
    chartSub: "Hamma hisoblar, USD da. Hisoblar orasidagi o'tkazmalar hisoblanmaydi.",
    chartEmpty: "Hali pul harakati yo'q. Hisoblarni Budjet → Pul bo'limida oching.",
    series: { in: "Kirim", out: "Chiqim", net: "Sof" },
    spendTitle: "Pul nimaga ketdi · {{month}}",
    spendEmpty: "Bu oyda chiqim yo'q.",
    other: "Boshqa",
    dueTitle: "To'lanishi va tushishi kerak",
    nothingDue: "Tasdiqlangan hamma narsa to'langan.",
    due: {
      expenses_one: "{{count}} ta tasdiqlangan xarajat",
      expenses_other: "{{count}} ta tasdiqlangan xarajat",
      salaries_one: "{{count}} ta to'lanmagan maosh",
      salaries_other: "{{count}} ta to'lanmagan maosh",
      bonuses_one: "{{count}} ta tasdiqlangan bonus",
      bonuses_other: "{{count}} ta tasdiqlangan bonus",
    },
    pay: "To'lash",
    open: "Ochish",
    payable: "Bizning qarzimiz",
    receivable: "Bizga qarz",
    feesExpected_one: "{{count}} ta carrier to'lovi kutilmoqda",
    feesExpected_other: "{{count}} ta carrier to'lovi kutilmoqda",
    feesOverdue_one: "{{count}} tasi muddati o'tgan",
    feesOverdue_other: "{{count}} tasi muddati o'tgan",
    feesNoAmount_one: "{{count}} tasida summa yo'q",
    feesNoAmount_other: "{{count}} tasida summa yo'q",
  },
};
